export class RunCustomFunctionMsg {
    /**
     * 当需要调用customFunction
     * @param story Story
     * @param sourceNode StoryNode
     * @param customFuncDest FunctionDest
     * @param runEnded 运行进行后，返回StoryNode
     */
    constructor(story, edge, customFuncDest, runEnded) {
        this.story = story;
        this.edge = edge;
        this.customFuncDest = customFuncDest;
        this.runEnded = runEnded;
        this.naming = "RunCustomFunctionMsg";
    }
}
